import { BranchLocation, LocationTreeWithRoot, Location } from '../types';
import normalizeLocationId from './normalizeLocationId';
import { isBranch } from './validations';

const findAncestorsThatNeedExpanding = (
  tree: LocationTreeWithRoot,
  targetLocation: Location
): BranchLocation[] => {
  const ancestors: BranchLocation[] = [];
  const [root] = tree;

  // If location has a path, use it to navigate
  if (!targetLocation.path) {
    return ancestors;
  }

  const pathParts = targetLocation.path.split('/').filter(Boolean);
  let currentNodes = root.children;

  pathParts.forEach((part) => {
    const normalizedPart = normalizeLocationId(part);
    const matching = currentNodes.find((node) => {
      return (
        node.name === part || normalizeLocationId(node.id) === normalizedPart
      );
    });

    if (!matching) {
      return;
    }

    if (matching && isBranch(matching)) {
      ancestors.push(matching);
      currentNodes = matching.children;
    }
  });

  return ancestors;
};

export default findAncestorsThatNeedExpanding;
